import { useMemo } from 'react';

import {
  Configuration,
  EmailContactsApiFactory,
  RestAIEmailUpdaterApiFactory,
  RestDraftAIEmailApiFactory,
  RestEmailFolderSettingsApiFactory,
  RestEmailReaderApiFactory,
  RestEmailSenderApiFactory,
  RestEmailUpdaterApiFactory,
} from '@/api/generated';
import { CONFIG } from '@/config/config.ts';

import { useAxiosInstance } from '../useAxiosInstance.util.tsx';

interface Return {
  aIEmailUpdaterApi: ReturnType<typeof RestAIEmailUpdaterApiFactory>;
  draftAIEmailApi: ReturnType<typeof RestDraftAIEmailApiFactory>;
  emailContactsApi: ReturnType<typeof EmailContactsApiFactory>;
  emailFolderSettingsApi: ReturnType<typeof RestEmailFolderSettingsApiFactory>;
  emailReaderApi: ReturnType<typeof RestEmailReaderApiFactory>;
  emailSenderApi: ReturnType<typeof RestEmailSenderApiFactory>;
  emailUpdateApi: ReturnType<typeof RestEmailUpdaterApiFactory>;
}

export const useEmailApiClient = (): Return => {
  const basePath = CONFIG.HOST;
  const configuration = getConfiguration(basePath);
  const axiosInstance = useAxiosInstance();

  return useMemo(() => {
    return {
      aIEmailUpdaterApi: RestAIEmailUpdaterApiFactory(configuration, undefined, axiosInstance),
      draftAIEmailApi: RestDraftAIEmailApiFactory(configuration, undefined, axiosInstance),
      emailContactsApi: EmailContactsApiFactory(configuration, undefined, axiosInstance),
      emailFolderSettingsApi: RestEmailFolderSettingsApiFactory(
        configuration,
        undefined,
        axiosInstance,
      ),
      emailReaderApi: RestEmailReaderApiFactory(configuration, undefined, axiosInstance),
      emailSenderApi: RestEmailSenderApiFactory(configuration, undefined, axiosInstance),
      emailUpdateApi: RestEmailUpdaterApiFactory(configuration, undefined, axiosInstance),
    };
  }, [axiosInstance]);
};

const getConfiguration = (basePath: string): Configuration => ({
  basePath,
  isJsonMime(_mime: string): boolean {
    return true;
  },
});
